import { getTenantId } from 'common/helpers/apiHelper';

export const isAllowInvalidPackages = () => {
  const allowedTenants = ['holm-oak-vineyards'];
  if (allowedTenants.includes(getTenantId())) {
    return true;
  }
  return false;
};

export const isEventTicketItemData = (type, sku) => {
  if (type !== 'Event Ticket') {
    return false;
  }
  if (!['2020HCM', '2020EBT', '1-event'].includes(sku)) {
    return false;
  }
  const allowedTenants = ['development', 'oliver-osoyoos-winery-association'];
  if (allowedTenants.includes(getTenantId())) {
    return true;
  }
  return false;
};

export const isShowSavings = () => {
  const allowedTenants = [
    'mumm-napa',
    'kenwood-vineyards',
    'staging-mumm-napa',
    'staging-kenwood-vineyards'
  ];
  if (!allowedTenants.includes(getTenantId())) {
    return true;
  }
  return false;
};

export const isPickupBy = () => {
  const allowedTenants = [
    'development',
    'rombauer-vineyards',
    'staging-rombauer'
  ];
  if (allowedTenants.includes(getTenantId())) {
    return true;
  }
  return false;
};

export const isRavenswood = () => {
  if (getTenantId() === 'ravenswoodwinery') {
    return true;
  }
  return false;
};

export const isConstellationAllocation = () => {
  const allowedTenants = [
    'development',
    'bottlecollective',
    'dreamingtreewines',
    'employeestore',
    'friendsandfamily',
    'meiomi',
    'mountveederwinery',
    'robertmondaviwinery',
    'simiwinery',
    'tokalon-vineyard-company',
    'theprisoner',
    'woodbridge'
  ];
  if (allowedTenants.includes(getTenantId())) {
    return true;
  }
  return false;
};

export const isGardenSociety = () => {
  const allowedTenants = ['garden-society'];
  if (allowedTenants.includes(getTenantId())) {
    return true;
  }
  return false;
};

export const isCoolPacks = () => {
  const allowedTenants = [
    'friendsandfamily',
    'development',
    'bottlecollective',
    'dreamingtreewines',
    'employeestore',
    'meiomi',
    'mountveederwinery',
    'robertmondaviwinery',
    'simiwinery',
    'theprisoner',
    'woodbridge'
  ];
  if (allowedTenants.includes(getTenantId())) {
    return true;
  }
  return false;
};

export const isJordanWinery = () => {
  const tenants = ['development', 'jordan-vineyard-and-winery'];
  if (tenants.includes(getTenantId())) {
    return true;
  }
  return false;
};

export const isNewAlerts = () =>
  // if (
  //   customer.id === '1773eee7-114a-44b8-a67b-b11f20b6e469' ||
  //   customer.id === 'a81ba21f-4624-4571-89c5-7a533597098a'
  // ) {
  //   return true;
  // }
  false;

export const isAddToClubShipment = () =>
  // if (
  //   (customer && customer.id === '1773eee7-114a-44b8-a67b-b11f20b6e469') ||
  //   (customer && customer.id === 'a81ba21f-4624-4571-89c5-7a533597098a')
  // ) {
  //   return true;
  // }
  false;

export const isPreSale = () => {
  const tenants = ['joyful-heart'];
  if (tenants.includes(getTenantId())) {
    return true;
  }
  return false;
};

export const isDarioush = () => {
  const tenants = ['darioush', 'staging-darioush', 'staging-2-darioush'];
  if (tenants.includes(getTenantId())) {
    return true;
  }
  return false;
};
